/**
 * Banner hotspot tooltips: keep hover/click behavior, ensure links activate via keyboard.
 */
(function () {
  var LINK_SEL = '.card-grid__item--tooltip-banner .card__tooltip a[href]';

  document.addEventListener(
    'click',
    function (e) {
      if (!e.target.closest(LINK_SEL)) return;
      e.stopPropagation();
    },
    true
  );

  document.addEventListener(
    'keydown',
    function (e) {
      var link = e.target.closest(LINK_SEL);
      if (!link) return;

      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
        e.preventDefault();
        e.stopPropagation();
        link.click();
      }
    },
    true
  );
})();